import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { terminateCards } from '../api/rsimActionsApi.ts';

export const useRSimTerminateMutation = (
  options?: Omit<UseMutationOptions<void, Error, { euiccIds: string[] }, unknown>, 'mutationFn'>,
) => {
  return useMutation({
    ...options,
    mutationFn: (props) => {
      return terminateCards(props);
    },
  });
};
